import {ICatalogo} from "../../entities/catalogos/ICatalogo";
import {LOAD_PAISES_SUCCESS} from "../types/paisActionTypes";
import useCommonApi from "../../api/useCommonApi";

const apiSource = useCommonApi();

export function loadPaises() {
    return function (dispatch) {
        return apiSource.obtener<ICatalogo[]>("pais/many")
            .then((paises: ICatalogo[]) => {
                dispatch({type: LOAD_PAISES_SUCCESS, paises})
            })
            .catch(error => {
                throw error;
            })
    }
}
